import styles from '@features/b2b-contact-form/styles/FormMessage.module.css';
import cn from 'classnames';
import React from 'react';

import { SuccessTickIcon } from '@shared/assets/icons/SuccessTickIcon';
import { ErrorIcon } from '@shared/assets/icons/ErrorIcon';

interface Props {
  message: string;
  type: 'success' | 'error';
}

export const FormMessage: React.FC<Props> = ({ message, type }) => {
  const isSuccess = type === 'success';

  return (
    <div className={styles.wrapper}>
      {isSuccess ? <SuccessTickIcon /> : <ErrorIcon />}
      <p
        className={cn(styles.messageText, {
          [styles.successMessageText]: isSuccess,
        })}
      >
        {message}
      </p>
    </div>
  );
};
